module.exports = __webpack_public_path__ + "img/gou.2806071e.png";